const formatTimestamp = (timestamp: string) => {
  const datetime = new Date(timestamp);
  return `${datetime.toLocaleDateString()} at ${datetime.toLocaleTimeString()}`;
};

export default formatTimestamp;
